@if (isConsultativeTransfer || (showTransferBar && transferType === TransferType.consultativeTransfer)) {
  <!-- Consultation view — mirrors app-transferring-session-footer structure exactly -->
  <div class="footer-wrapper">
    <div class="sessions-wrapper">
      <!-- Main session row (hidden for consultant view) -->
      @if (!isConsultantView) {
        <div class="session-footer-bar" [ngClass]="isConferenced ? 'conferenced' : (task?.conversationState | lowercase)">
          <div class="session-state"></div>
          <div class="footer-content">
            <div class="footer-title">
              <nimbus-avatar [customIcon]="ICONS.USER_LIGHT"></nimbus-avatar>
              @if (isConferenced && consultantName && !isCallerGone) {
                <span class="caller-name">
                  {{ task?.caller?.displayName }}, {{ consultantName }}
                  <nimbus-tooltip [text]="task?.caller?.displayName + ', ' + consultantName" [position]="'bottom'"></nimbus-tooltip>
                </span>
              } @else if (isConferenced && consultantName && isCallerGone) {
                <span class="caller-name">
                  {{ consultantName }}
                  <nimbus-tooltip [text]="consultantName" [position]="'bottom'"></nimbus-tooltip>
                </span>
              } @else {
                <span class="caller-name">
                  {{ task?.caller?.displayName }}
                  <nimbus-tooltip [text]="task?.caller?.displayName" [position]="'bottom'"></nimbus-tooltip>
                </span>
              }
            </div>
            <div class="footer-subtitle">
              <span>
                @if (mainSessionStateKey) {
                  {{ mainSessionStateKey | translate }}
                }
                @if (task?.isDirectCall) {
                  :&nbsp;{{ TranslationKeys.AssistantTaskFooterDirectCall | translate }}
                } @else if (task?.since) {
                  :&nbsp;{{ task.since | dateDifference: (currentMoment$ | async) | durationFormat: 'auto' }}
                }
              </span>
            </div>
          </div>
        </div>
      }
      <!-- end @if (!isConsultantView) -->
      <!-- Consultation session row — hidden during conference for non-consultant; always shown for consultant -->
      @if (consultantName && (!isConferenced || isConsultantView)) {
        <div class="session-footer-bar" [ngClass]="consultationSessionStateClass">
          <div class="session-state"></div>
          <div class="footer-content">
            <div class="footer-title">
              <nimbus-avatar [customIcon]="ICONS.USER_LIGHT"></nimbus-avatar>
              <span class="caller-name">{{ consultantName }}</span>
            </div>
            <div class="footer-subtitle">
              <span>
                @if (consultationStateKey) {
                  {{ consultationStateKey | translate }}
                }
                @if (consultationSince) {
                  :&nbsp;{{ consultationSince | dateDifference: (currentMoment$ | async) | durationFormat: 'auto' }}
                }
              </span>
            </div>
            @if (!isConsultationStarting && !isConsultantView) {
              <div class="footer-consultative-actions">
                <div
                  class="session-footer-action cancellation"
                  [class.disabled]="actionsDisabled$ | async"
                  (click)="onTerminateConsultation()"
                >
                  <div class="action-content">
                    <i [nimbusIcon]="ICONS.DECLINE"></i>
                    <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsTerminate | translate }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="actions-wrapper">
      @if (!isConsultantView) {
        @if (showConsultationTransferAction) {
          <div
            class="session-footer-action"
            [class.disabled]="(actionsDisabled$ | async) || isConsultationStarting || !activeConsultation"
            (click)="onTransferConsultation()"
          >
            <div class="action-content">
              <i [nimbusIcon]="ICONS.SB_TRANSFER"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsTransfer | translate }}</span>
            </div>
          </div>
        }
        @if (showConsultationConferenceAction) {
          <div
            class="session-footer-action"
            [class.disabled]="(actionsDisabled$ | async) || isConsultationStarting || !activeConsultation"
            (click)="onConference()"
          >
            <div class="action-content">
              <i [nimbusIcon]="ICONS.USER_FRIENDS"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsConference | translate }}</span>
            </div>
          </div>
        }
        @if (showConsultationSwapAction) {
          <div class="session-footer-action" [class.disabled]="(actionsDisabled$ | async) || !activeConsultation" (click)="onSwap()">
            <div class="action-content">
              <i [nimbusIcon]="ICONS.ARROW_UP_DOWN"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsSwap | translate }}</span>
            </div>
          </div>
        }
        @if (!isConferenced) {
          <div
            class="session-footer-action"
            [class.disabled]="(actionsDisabled$ | async) || !activeConsultation"
            (click)="onHangupAndRetrieve()"
          >
            <div class="action-content">
              <i [nimbusIcon]="ICONS.DECLINE_RETRIEVE"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsHangupWithDots | translate }}</span>
            </div>
            <nimbus-tooltip
              [text]="TranslationKeys.AssistantSessionFooterActionsHangupAndRetrieve | translate"
              [position]="'above'"
            ></nimbus-tooltip>
          </div>
        }
        @if (isConsultationStarting) {
          <div class="session-footer-action cancellation" [class.disabled]="actionsDisabled$ | async" (click)="onTerminateConsultation()">
            <div class="action-content">
              <i [nimbusIcon]="ICONS.DECLINE"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsTerminate | translate }}</span>
            </div>
          </div>
        }
        @if (isConferenced) {
          <div class="session-footer-action cancellation" [class.disabled]="actionsDisabled$ | async" (click)="onTerminateCall()">
            <div class="action-content">
              <i [nimbusIcon]="ICONS.DECLINE"></i>
              <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsHangup | translate }}</span>
            </div>
          </div>
        }
      }
      @if (isConsultantView && !isConsultationStarting) {
        <div class="session-footer-action cancellation" [class.disabled]="actionsDisabled$ | async" (click)="onTerminateConsultation()">
          <div class="action-content">
            <i [nimbusIcon]="ICONS.DECLINE"></i>
            <span class="action-text">{{ TranslationKeys.AssistantSessionFooterActionsTerminate | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>
} @else if (showTransferBar) {
  <!-- Transfer in-progress / result view -->
  <div class="transfer-state-footer" [ngClass]="transferStateClass">
    <div class="session-state-bar"></div>
    <div class="state-content">
      <div class="state-title">
        <i [nimbusIcon]="ICONS.USER_LIGHT" [iconWeight]="IconWeight.Regular" class="caller-icon"></i>
        <span class="caller-name">{{ callerName }}</span>
      </div>
      <div class="state-subtitle">
        @switch (transferState) {
          @case (TransferState.TransferSuccessful) {
            <i [nimbusIcon]="ICONS.SUCCESS" [iconWeight]="IconWeight.Regular" class="state-icon success"></i>
            <span>{{ TranslationKeys.AssistantSessionFooterConversationStateTransferSuccessful | translate }}</span>
          }
          @case (TransferState.TransferFailed) {
            <i [nimbusIcon]="ICONS.TIMES_CIRCLE" [iconWeight]="IconWeight.Regular" class="state-icon failed"></i>
            <span>{{ transferErrorMessage || TranslationKeys.AssistantSessionFooterConversationStateTransferFailed | translate }}</span>
          }
          @default {
            <i [nimbusIcon]="ICONS.SPINNER" class="state-icon transferring-spinner"></i>
            <span>{{ TranslationKeys.AssistantSessionFooterConversationStateTransferring | translate }}</span>
          }
        }
      </div>
    </div>
  </div>
} @else {
  <!-- Transfer buttons (initial state) -->
  <div class="transfer-footer">
    <div class="transfer-action" [class.disabled]="isDisabled" (click)="onSafeTransfer()">
      <div class="action-content">
        <i [nimbusIcon]="ICONS.SB_TRANSFER"></i>
        <span class="action-text">{{ TranslationKeys.AssistantCallFooterSafeTransfer | translate }}</span>
      </div>
      <nimbus-tooltip [text]="safeTransferTooltip | translate" [position]="'above'"></nimbus-tooltip>
    </div>
    <div class="transfer-action" [class.disabled]="isDisabled" (click)="onBlindTransfer()">
      <div class="action-content">
        <i [nimbusIcon]="ICONS.SB_DIRECT_TRANSFER"></i>
        <span class="action-text">{{ TranslationKeys.AssistantCallFooterBlindTransfer | translate }}</span>
      </div>
      <nimbus-tooltip [text]="blindTransferTooltip | translate" [position]="'above'"></nimbus-tooltip>
    </div>
    <div class="transfer-action" [class.disabled]="isDisabled" (click)="onConsultativeTransfer()">
      <div class="action-content">
        <i [nimbusIcon]="ICONS.CONSULTATION_CALL"></i>
        <span class="action-text">{{ TranslationKeys.AssistantCallFooterConsultativeTransfer | translate }}</span>
      </div>
      <nimbus-tooltip [text]="consultativeTransferTooltip | translate" [position]="'above'"></nimbus-tooltip>
    </div>
  </div>
}
